import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-white/10 bg-black text-white"
    >
      <div className="grid grid-cols-12 gap-6 px-4 md:px-6 py-12 border-b border-white/10">
        <div className="col-span-12 md:col-span-5">
          <p className="font-display text-2xl leading-tight">
            440 Wyandanch Avenue
            <br />
            North Babylon, NY 11704
          </p>
          <img
            src="/assets/anron_logo_light.png"
            alt="Anron Air Systems"
            data-testid="footer-logo"
            className="mt-8 h-10 md:h-12 w-auto opacity-90"
          />
        </div>

        <div className="col-span-6 md:col-span-4">
          <p className="font-mono text-sm uppercase tracking-[0.2em] text-white/60 mb-4">
            Contact Us
          </p>
          <ul className="space-y-2 text-sm text-white/70">
            <li>
              <a
                href="tel:+16316433433"
                className="hover:text-white transition-colors"
                data-testid="footer-phone"
              >
                Phone · 631.643.3433
              </a>
            </li>
            <li>
              <span className="text-white/60">Fax · 631.491.6983</span>
            </li>
            <li>
              <a
                href="mailto:info@anronac.com"
                className="hover:text-white transition-colors"
                data-testid="footer-email"
              >
                info@anronac.com
              </a>
            </li>
            <li className="text-white/50 font-mono text-xs">Mon-Fri 8:00 - 5:00</li>
          </ul>
        </div>

        <div className="col-span-6 md:col-span-3">
          <p className="font-mono text-sm uppercase tracking-[0.2em] text-white/60 mb-4">
            Quick Tabs
          </p>
          <ul className="space-y-2 text-sm">
            {[
              ["/", "Home"],
              ["/about", "About"],
              ["/projects", "Projects"],
              ["/service", "Service"],
              ["/links", "Links"],
              ["/contact", "Contact"],
            ].map(([to, label]) => (
              <li key={to}>
                <Link
                  to={to}
                  className="text-white/70 hover:text-white transition-colors"
                  data-testid={`footer-link-${label.toLowerCase()}`}
                >
                  → {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div
        data-testid="footer-affiliations"
        className="border-b border-white/10 px-4 md:px-6 py-6 flex items-center justify-between gap-4 md:gap-8 flex-nowrap overflow-x-auto"
      >
        {[
          { name: "MSCA", url: "http://www.mcaa.org/msca/", src: "/assets/logo_msca.webp" },
          { name: "SMACNA", url: "http://www.smacna.org/", src: "/assets/logo_smacna.png" },
          { name: "ASHRAE", url: "http://www.ashrae.org/", src: "/assets/logo_ashrae.webp" },
          { name: "ACCA", url: "http://www.acca.org/", src: "/assets/logo_acca.png" },
          { name: "SPIDA", url: "http://www.spida.org/", src: "/assets/logo_spida.png" },
        ].map((org) => (
          <a
            key={org.name}
            href={org.url}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={org.name}
            data-testid={`footer-affiliation-${org.name.toLowerCase()}`}
            className="inline-flex items-center shrink-0 transition-transform duration-300 hover:-translate-y-0.5"
          >
            <img
              src={org.src}
              alt={org.name}
              className="h-8 md:h-12 w-auto"
            />
          </a>
        ))}
      </div>

      <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-3 px-4 md:px-6 py-4 font-mono text-[10px] uppercase tracking-widest text-white/40">
        <p>© {new Date().getFullYear()} Anron Air Systems, Inc. All Rights Reserved.</p>
        <p>Built for Industry — North Babylon, NY · Est. 1965</p>
      </div>
    </footer>
  );
}
